import axios from '@/api/requests/axios'

export default {
  getCallbacks: params => axios.get('/api/admin/v1/payments/callbacks', { params }),
}
